var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MultipleChoicesDropdown',{attrs:{"title":"Region","value":_vm.value,"show-clear-all":false,"single-choice":_vm.singleChoice,"search-enabled":false,"choices":_vm.choices},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }